// extracted by mini-css-extract-plugin
var _1 = "Header_demoMode__an8Wy";
var _2 = "Header_demoModeNotice__zrGl5";
var _3 = "Header_demoModeNoticeSeparator__+aibk";
var _4 = "Header_demoModeNoticeTextExtra__zYU-D";
var _5 = "Header_demoModeNoticeTextMain__8aJxY";
var _6 = "Header_demoModeNoticeTexts__tvvmh";
var _7 = "Header_hideOnSmall__c8C51";
var _8 = "Header_hideOnSmallFeedback__Hw3rc";
var _9 = "Header_hideOnSmallGithub__BpwGu";
var _a = "Header_logo__shVBB";
var _b = "Header_logoIcon__5-f8I";
var _c = "Header_menuRight__RgdT+";
var _d = "Header_notification__IkN6+";
var _e = "Header_title__l+wMf";
var _f = "Header_wrapper__SXTn0";
export { _1 as "demoMode", _2 as "demoModeNotice", _3 as "demoModeNoticeSeparator", _4 as "demoModeNoticeTextExtra", _5 as "demoModeNoticeTextMain", _6 as "demoModeNoticeTexts", _7 as "hideOnSmall", _8 as "hideOnSmallFeedback", _9 as "hideOnSmallGithub", _a as "logo", _b as "logoIcon", _c as "menuRight", _d as "notification", _e as "title", _f as "wrapper" }
